require("select2");
require("jquery-validation");
// require("../../modal/register");

$(document).ready(function () {
  $(".Country").select2();
  $(".PhoneCode").select2({
    templateSelection: (state) => {
      if (!state.id) {
        return state.text;
      } else {
        return state.id;
      }
    },
  });

  $("#register-form").validate({
    onsubmit: false,
    focusCleanup: true,
    onkeyup: function (element) {
      $(element).valid();
    },
    rules: {
      FirstName: "required",
      LastName: "required",
      Country: "required",
      PhoneCode: "required",
      EmailAddr: {
        required: true,
        email: true,
      },
      PhoneNumber: {
        required: true,
        minlength: 8,
        maxlength: 15,
      },
      Password: {
        required: true,
        minlength: 6,
      },
      Password_confirmation: {
        required: true,
        equalTo: "#Password",
      },
    },
    messages: {
      FirstName: "Please enter your firstname",
      LastName: "Please enter your lastname",
      EmailAddr: "Please enter a valid email address",
      PhoneCode: "Please select code",
      Country: "Please select country",
      PhoneNumber: {
        required: "Please enter your phone number",
        minlength: "Please enter a valid phone number",
        maxlength: "Please enter a valid phone number",
      },
      Password: {
        required: "Please provide a password",
        minlength: "Your password must be at least 6 characters long",
      },
      Password_confirmation: {
        required: "Please confirm your password",
        equalTo: "Your password does not match",
      },
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element);
    },
  });
});
